import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Location } from "@angular/common";
import { MitterService } from '../../../services/mitter.service';
import { getTimelineEvent, makeMessage } from '../../utils/message-utils';
import {ActivatedRoute, Router, Params } from '@angular/router';

@Component({
  selector: 'app-image-form',
  templateUrl: './image-form.component.html',
  styleUrls: ['./image-form.component.css']
})
export class ImageFormComponent implements OnInit {
  @ViewChild('fileSelector') fileSelector: ElementRef;
  @ViewChild('selectedImage') selectedImage: ElementRef;
  mitter: any;
  textPayload: string = '';
  file: any;
  channelId: string;

  userRole: string;
  isDoctor: boolean;
  isPrescription: boolean;

  constructor(private mitterService: MitterService,
      private location: Location, private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.channelId = params['chatid'];
    });

    this.mitterService.synchUser(false)
      .then(() => this.mitter = this.mitterService.getMitter())
      .then(() => this.userRole = this.mitterService.getUserRole())
      .then(() => this.isDoctor = this.userRole === "DOCTOR");
  }

  goBack() {
    this.location.back();
  }

  onChange(files) {
    if (files.length >= 0) {
      this.file = files[0];

      let fileReader = new FileReader();
      fileReader.onload =
        () => this.selectedImage.nativeElement.src = fileReader.result;
      fileReader.readAsDataURL(this.file);
    }
  }

  sendImageMessage() {
    if(!this.file) return;
    const userId = this.mitter.getUserId();
    const sentTimeEvent = getTimelineEvent('mitter.mtet.SentTime', userId);
    const message = makeMessage('Standard', 'mitter.mt.Image', userId, this.textPayload, [sentTimeEvent]);
    if (this.isPrescription) {
      message['messageData'] = [{
        dataType: 'petcart.messageInfo',
        data: {
          isPrescription: true
        }
      }];
    }

    this.mitter.sendMultipartMessageAsync(this.channelId, message, this.file)
      .then(() => this.textPayload = '')
      .then(() => this.goBack());

  }

  handleKeyDown(event) {
    if (event.keyCode == 13) {
      if (!event.shiftKey) {
        this.sendImageMessage();
        event.preventDefault();
      }
    }
  }

  togglePrescription() {
    this.isPrescription = !this.isPrescription;
  }
}
